import { type ReactNode } from 'react'
import { Navigate } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'

export function ProtectedRoute({ children }: { children: ReactNode }) {
  const { artist, loading } = useAuth()

  if (loading) return <p className="state-loading">Loading…</p>
  if (!artist) return <Navigate to="/login" replace />

  return <>{children}</>
}
